export type ClassValue = string | number | boolean | undefined | null;

/** Concatène des classes Tailwind / CSS (merge simple, sans tailwind-merge). */
export function cn(...inputs: ClassValue[]): string {
  return inputs.filter(Boolean).join(" ");
}

/** UUID v4 ; fallback si `crypto.randomUUID` absent (ex. HTTP non sécurisé sur mobile). */
export function generateUUID(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
